(function () {
  'use strict';

  var PRODUCT_PATH_PREFIX = '/products/';
  var SOURCE_KEY = 'piProductBackSource';
  var DEPTH_KEY = 'piProductBackDepth';
  var isSkippingBack = false;

  function isProductPath(pathname) {
    return typeof pathname === 'string' && pathname.indexOf(PRODUCT_PATH_PREFIX) === 0;
  }

  function parseUrl(value) {
    if (!value) return null;

    try {
      return new URL(value, window.location.origin);
    } catch (error) {
      return null;
    }
  }

  function isSameOrigin(url) {
    return url && url.origin === window.location.origin;
  }

  function clearStoredChain() {
    sessionStorage.removeItem(SOURCE_KEY);
    sessionStorage.removeItem(DEPTH_KEY);
  }

  function storeChain(sourceUrl, depth) {
    sessionStorage.setItem(SOURCE_KEY, sourceUrl);
    sessionStorage.setItem(DEPTH_KEY, String(depth));
  }

  function getStoredDepth() {
    var depth = parseInt(sessionStorage.getItem(DEPTH_KEY), 10);
    return Number.isFinite(depth) && depth > 0 ? depth : 0;
  }

  function getChainContext() {
    var referrerUrl = parseUrl(document.referrer);

    if (!isSameOrigin(referrerUrl)) {
      clearStoredChain();
      return null;
    }

    if (isProductPath(referrerUrl.pathname)) {
      var storedSource = sessionStorage.getItem(SOURCE_KEY);
      var storedDepth = getStoredDepth();

      if (!storedSource || storedDepth < 1) {
        clearStoredChain();
        return null;
      }

      storeChain(storedSource, storedDepth + 1);

      return {
        source: storedSource,
        depth: storedDepth + 1
      };
    }

    var sourceUrl = referrerUrl.href;
    storeChain(sourceUrl, 1);

    return {
      source: sourceUrl,
      depth: 1
    };
  }

  function ensureSentinelState(context) {
    var currentState = history.state || {};

    if (
      currentState.__piProductBackSentinel === true &&
      currentState.__piProductBackSource === context.source &&
      currentState.__piProductBackDepth === context.depth
    ) {
      return;
    }

    history.replaceState(
      {
        __piProductBackBase: true,
        __piProductBackSource: context.source,
        __piProductBackDepth: context.depth
      },
      '',
      window.location.href
    );

    history.pushState(
      {
        __piProductBackSentinel: true,
        __piProductBackSource: context.source,
        __piProductBackDepth: context.depth
      },
      '',
      window.location.href
    );
  }

  function handleBackJump(event) {
    if (isSkippingBack) return;

    var state = event.state || {};

    if (state.__piProductBackBase !== true) {
      return;
    }

    var depth = parseInt(state.__piProductBackDepth, 10);
    if (!Number.isFinite(depth) || depth < 1) {
      return;
    }

    isSkippingBack = true;
    history.go(-(depth * 2 - 1));
  }

  if (!isProductPath(window.location.pathname)) {
    return;
  }

  var context = getChainContext();
  if (!context) {
    return;
  }

  ensureSentinelState(context);
  window.addEventListener('popstate', handleBackJump);
})();
